"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : FILTER : STYLES --------------- ++++++++++ */


var _default = {
  filteritem: {
    display: 'inline-block',
    fontSize: (0, _index.pxToEm)(14),
    marginRight: (0, _index.pxToEm)(50),
    marginBottom: (0, _index.pxToEm)(35),
    '&:last-child': {
      marginRight: '0',
      marginBottom: '0'
    },
    '& .filteritem-title-div': {
      marginBottom: (0, _index.pxToEm)(20)
    },
    '& .filteritem-title': {
      color: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 40),
      fontWeight: '600',
      '& .icon': {
        marginRight: (0, _index.pxToEm)(10),
        color: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 20)
      }
    },
    '& .list': {
      margin: 0,
      height: (0, _index.pxToEm)(160),
      paddingLeft: (0, _index.pxToEm)(10),
      overflow: 'scroll',
      '& .checkbox': {
        height: (0, _index.pxToEm)(16),
        width: (0, _index.pxToEm)(16)
      },
      '& .list-item': {
        margin: 0,
        marginTop: (0, _index.pxToEm)(15),
        '& .option-text': {
          display: 'flex',
          alignItems: 'center',
          height: (0, _index.pxToEm)(28),
          color: _index.theme.color.supporting.dark.swatch,
          opacity: 1
        }
      },
      '& .contenttype': {
        height: '100%',
        '& .contenttypeinner': {
          width: (0, _index.pxToEm)(68),
          height: '100%',
          display: 'block',
          borderRadius: (0, _index.pxToEm)(14),
          '& .icon': {
            textTransform: 'capitalize',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: (0, _index.pxToEm)(14)
          }
        }
      }
    },
    '& .name-admins': {
      height: (0, _index.pxToEm)(150),
      paddingLeft: (0, _index.pxToEm)(10),
      paddingRight: (0, _index.pxToEm)(20),
      overflow: 'scroll'
    },
    // specific filteritem filters
    '&.type': {
      minWidth: (0, _index.pxToEm)(145)
    },
    '&.status': {
      minWidth: (0, _index.pxToEm)(194)
    },
    '&.flagged': {
      minWidth: (0, _index.pxToEm)(97)
    },
    '&.notes': {
      minWidth: (0, _index.pxToEm)(115)
    },
    '&.admins': {
      minWidth: (0, _index.pxToEm)(155)
    }
  }
};
exports.default = _default;